import React, { useState } from 'react';
import { Printer, QrCode, User } from 'lucide-react';
import { printBadge } from '../../../utils/badgePrint';

const Badge = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [qrUrl, setQrUrl] = useState('https://trunk.treehacks.com/p/');

  const canPrint = firstName.trim().length > 0;

  const handlePrint = () => {
    if (!canPrint) return;
    const effectiveQrUrl = qrUrl.trim().replace(/\/+$/, '') === 'https://trunk.treehacks.com/p' ? '' : qrUrl.trim();
    printBadge(firstName.trim(), lastName.trim(), null, effectiveQrUrl);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && canPrint) {
      handlePrint();
    }
  };

  return (
    <div className='max-w-2xl mx-auto p-6'>
      <div className='flex items-center gap-3 mb-6'>
        <h1 className='font-bold text-3xl'>Badge Printer</h1>
      </div>

      <div className='bg-white rounded-lg shadow p-6 space-y-5'>
        {/* First Name */}
        <div>
          <label className='flex items-center space-x-2 text-sm font-medium text-gray-700 mb-1'>
            <User className='h-4 w-4 text-gray-500' />
            <span>First Name *</span>
          </label>
          <input
            type='text'
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='e.g. Jane'
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg'
          />
        </div>

        {/* Last Name */}
        <div>
          <label className='flex items-center space-x-2 text-sm font-medium text-gray-700 mb-1'>
            <User className='h-4 w-4 text-gray-500' />
            <span>Last Name</span>
          </label>
          <input
            type='text'
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='e.g. Doe'
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg'
          />
        </div>

        {/* QR Code URL */}
        <div>
          <label className='flex items-center space-x-2 text-sm font-medium text-gray-700 mb-1'>
            <QrCode className='h-4 w-4 text-gray-500' />
            <span>QR Code URL</span>
          </label>
          <input
            type='text'
            value={qrUrl}
            onChange={(e) => setQrUrl(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='https://trunk.treehacks.com/p/...'
            className='w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm font-mono'
          />
          <p className='text-xs text-gray-400 mt-1'>
            Leave empty to print a badge without a QR code.
          </p>
        </div>

        {/* Print Button */}
        <button
          onClick={handlePrint}
          disabled={!canPrint}
          className={`w-full py-3 px-4 rounded-lg font-medium text-white text-lg flex items-center justify-center space-x-2
            ${
              canPrint
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-gray-300 cursor-not-allowed'
            }`}>
          <Printer className='h-5 w-5' />
          <span>Print Badge</span>
        </button>
      </div>
    </div>
  );
};

export default Badge;
